<!--
  --
  -- 電話番号入力コンポーネント
  --
  -->
<template>
  <v-text-field
    label="電話番号"
    type="text"
    v-model="form.phone"
    :rules="[rule.required('電話番号'), rule.phone]"
  />
</template>

<script>
export default {
  name: 'CProfilePhone',
  props: {
    form: {
      type: Object,
      required: true
    }
  }
}
</script>
